import { Directive, Input, ElementRef, HostListener, OnChanges } from '@angular/core';

@Directive({
    selector: '[rotate]',
    standalone: false
})
export class RotateDirective implements OnChanges {
  @Input()
  rotate: number;

  constructor(private el: ElementRef) {}

  ngOnChanges(changes) {
    if (changes.rotate) {
      this.el.nativeElement.style.transform = `translateY(-50%) translateX(-50%) rotate(${this.rotate}deg)`;
    }
  }
}
